import React from "react";
import { Paper, Typography } from "@mui/material";
import "./TrustPanel.css";

const natePhoto = `${process.env.PUBLIC_URL}/assets/NatePhoto.png`;

export default function TrustPanel({
  title = "Work directly with Nate",
  body = "You’ll work directly with the person handling the project — not a big agency handoff or anonymous support queue. Clear communication, practical solutions, and fast follow-through.",
  photoAlt = "Portrait of Nate Parish, founder of Brainwave Solutions",
  badges = ["Based in the USA", "Native English speaker", "Direct communication"],
}) {
  return (
    <a href="/contact">
    <Paper className="bws-trustPanel" elevation={0}>
      <div className="bws-trustPanelInner">
        <img className="bws-trustPanelPhoto" src={natePhoto} alt={photoAlt} />

        <div className="bws-trustPanelContent">
          <Typography className="bws-trustPanelTitle">{title}</Typography>
          <Typography className="bws-trustPanelBody">{body}</Typography>

          {Array.isArray(badges) && badges.length > 0 && (
            <div className="bws-trustPanelBadges">
              {badges.map((badge) => (
                <span key={badge} className="bws-trustPanelBadge">
                  {badge}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </Paper>
    </a>
  );
}